import {InertiaLink, usePage} from "@inertiajs/inertia-react";
import {createColumnHelper} from "@tanstack/react-table";
import {IconButton} from "@material-ui/core";
import {Trans} from "../../utils/i18n";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import CreateIcon from "@material-ui/icons/Create";
import dayjs from "dayjs";
import React, {useMemo} from "react";

export default function useAmazonLockerTableConfig() {
    const {extendedMode, permissions, requesttypes, active_requesttype, partners, companies,} = usePage().props;

    return useMemo(() => {
        const columnHelper = createColumnHelper();

        return [
            columnHelper.display({
                id: 'collapse',
                cell: ({row}) => (
                    <div className="px-1">
                        <IconButton
                            aria-label={<Trans i18nKey="queues.expandRow">expand row</Trans>}
                            size="small"
                            onClick={row.getToggleSelectedHandler()}
                        >
                            {row.getIsSelected() ? <KeyboardArrowUpIcon/> : <KeyboardArrowDownIcon/>}
                        </IconButton>
                    </div>
                ),
            }),
            columnHelper.accessor(row => row.number, {
                id: 'number',
                header: () => <Trans i18nKey="queues.jobNumber">Job number</Trans>,
            }),
            columnHelper.accessor(row => row.orderattributes.filter(item => item.key === 'case_id').map((attribute) => (attribute.value)), {
                id: 'orderattributes.case_id',
                header: () => "Case ID",
                enableSorting: false,
            }),
            columnHelper.accessor(row => row.orderattributes.filter(item => item.key === 'intervention_id').map((attribute) => (attribute.value)), {
                id: 'orderattributes.intervention_id',
                header: () => "Intervention ID",
                enableSorting: false,
            }),
            columnHelper.accessor(row => row.orderattributes.filter(item => item.key === 'locker_service_type').map((attribute) => (attribute.value)), {
                id: 'orderattributes.locker_service_type',
                header: () => "Locker Service Type",
                enableSorting: false,
            }),
            // columnHelper.accessor(row => row.orderattributes.filter(item => item.key === 'service_code').map((attribute) => (attribute.value)), {
            //     id: 'orderattributes.service_code',
            //     header: () => "Service Code",
            //     enableSorting: false,
            // }),
            columnHelper.accessor(row => row.installation_address?.name, {
                id: 'addresses.name',
                header: () => <Trans i18nKey="queues.customer">Customer</Trans>,
            }),
            columnHelper.accessor(row => row.created_at, {
                id: 'created_at',
                header: () => <Trans i18nKey="queues.creationDate">Creation date</Trans>,
            }),
            columnHelper.accessor(row => row.status?.currentStatus?.name, {
                id: 'statuses.name',
                header: () => <Trans i18nKey="queues.status">Status</Trans>,
            }),
            columnHelper.accessor(row => row.appointment_date, {
                id: 'appointment_date',
                header: () => <Trans i18nKey="queueDetail.appointmentDate">Appointment date</Trans>,
            }),
            // columnHelper.accessor(row => row.status?.currentStatus?.exception, {
            //     id: 'exception',
            //     header: () => <Trans i18nKey="queues.exception">Exception</Trans>,
            //     enableSorting: false,
            // }),
            columnHelper.accessor(row => row.start_datetime, {
                id: 'start_datetime',
                header: () => <Trans i18nKey="queueDetail.start_datetime.label">On-Site Start Date & Time</Trans>,
                enableSorting: false,
            }),
            columnHelper.accessor(row => row.orderattributes.find(item => item.key === "sla")?.value, {
                id: 'orderattributes.sla',
                header: () => <Trans i18nKey="queueDetail.orderattributes.sla.label">SLA</Trans>,
                enableSorting: false,
            }),
            columnHelper.accessor(row => row.products.map(item => item.number).join(', '), {
                id: 'product',
                header: () => <Trans i18nKey="queueDetail.product.label">Product</Trans>,
                enableSorting: false,
            }),
            columnHelper.accessor(row => dayjs(row.status?.currentStatus?.datetime).format('DD.MM.YYYY HH:mm'), {
                id: 'statuses.updated_at',
                header: () => <Trans i18nKey="queues.statustime">Status time</Trans>,
            }),
            columnHelper.display({
                id: 'action',
                header: () => <Trans i18nKey="queues.action">Action</Trans>,
                cell: ({row}) => {
                    return <div>
                        <InertiaLink href={route('queue.details', {order: row.original?.order_id})}>
                            <CreateIcon color={'primary'}/>
                        </InertiaLink>
                    </div>;
                }
            }),
        ];
    }, []);
}
